/* eslint-disable max-len */
import { Dispatch } from 'redux';
import { IConfig } from 'src/interfaces';
import configService from 'src/services/config.service';

import { ConfigActionType } from '../action-types';
import { ConfigAction } from '../actions';

export const getConfig = (token: string) => async (dispatch: Dispatch<ConfigAction>) => {
  dispatch({
    type: ConfigActionType.GET_CONFIG,
  });

  try {
    const { data }: { data: IConfig } = await configService.getConfig(token);

    dispatch({
      type: ConfigActionType.GET_CONFIG_SUCCESS,
      payload: { config: data },
    });
  } catch (err: any) {
    dispatch({
      type: ConfigActionType.GET_CONFIG_FAILURE,
      payload: err.message,
    });
  }
};

export const patchConfig = (payload: Partial<IConfig>) => async (dispatch: Dispatch<ConfigAction>) => {
  try {
    await configService.patchConfig(payload);

    dispatch({
      type: ConfigActionType.PATCH_CONFIG_SUCCESS,
      payload: { config: payload as IConfig },
    });
  } catch (err: any) {
    dispatch({
      type: ConfigActionType.PATCH_CONFIG_FAILURE,
      payload: err.message,
    });
  }
};
